import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subheader1',
  templateUrl: './subheader1.component.html',
  styleUrls: ['./subheader1.component.css']
})
export class Subheader1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
